const reducer = (state: WtrState, action: { payload: { error: string } }) => ({
  ...state,
  loading: false,
  slots: [],
  error: action.payload.error,
});

export default reducer;
